export const edit = {
  type: "EDIT_FORM_FIELD"
}

export const update = {
  type: "UPDATE_PROFILE_IMAGE"
}

export const addAvatar = "ADD USER AVATAR";